// Set up the config object
window.lazySizesConfig = window.lazySizesConfig || {};

// load all elements after the window onload event
window.lazySizesConfig.preloadAfterLoad = true;

// load not so near view elements
window.lazySizesConfig.loadMode = 3;
